import { render, staticRenderFns } from "./CreateThirdLevel.vue?vue&type=template&id=13613633"
import script from "./CreateThirdLevel.vue?vue&type=script&lang=js"
export * from "./CreateThirdLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports